function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ArrowLeftOutlineIcon from './arrow-left-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowLeftIcon(props) {
  return ___EmotionJSX(ArrowLeftOutlineIcon, props);
}
export function ArrowLeftIconSmall(props) {
  return ___EmotionJSX(ArrowLeftOutlineIcon, _extends({
    size: "small"
  }, props));
}